const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const NAME_REGEX = /^[a-z ,.'-]+$/i;
const PHONE_REGEX = /^(\+\d{1,3}[- ]?)?\d{10}$/;
const PHONE_REGEX2 = /0{5,}/;
const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,30}$/;
const NonNumeric_REGEX = /^[a-zA-Z.' ]+$/;


export function NonNumericValidation (name) {
   return NonNumeric_REGEX.test(name.trim());
} 

export function EmailValidation (email) {
    return EMAIL_REGEX.test(email.trim());
 } 

 export function NameValidation (name) {
   return NAME_REGEX.test(name.trim());
} 

export function PhoneValidation(number){
   return PHONE_REGEX.test(number.trim()) && !(PHONE_REGEX2.test(number.trim()))
}

export function PasswordValidation (pass) {
   return PASSWORD_REGEX.test(pass.trim());
} 

